import React from "react";
import { View } from "react-native";
import { gridUnit } from "../styles/layout.js";
const Spacer = React.memo(function Spacer(props) {
    const size = props.units * gridUnit;
    return <View style={{ width: size, height: size }}/>;
});
export default Spacer;
//# sourceMappingURL=Spacer.js.map